import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentLegReportStatus } from '../../../selectors/screen';

export const useReportAdapter = (value, onClick) => {
    const { count = 0, sended = 0 } = useSelector(getCurrentLegReportStatus);
    
    const handleClick = useCallback(() => onClick(value), []);

    return { count, sended, handleClick };
};
